import React from "react";

import { useRoutes } from "react-router-dom";

import { screenRoutes } from "@/features/SolarForm";
import { ErrorPage } from "@/pages/ErrorPage";
import { GettingStartPage } from "@/pages/GettingStartPage";
import { SolarFormPage } from "@/pages/SolarFormPage";

export const BASE_PATH = "/electrify/quote";

export default function AppRouters() {
  const routes = useRoutes([
    {
      path: "/",
      element: <GettingStartPage />,
    },
    {
      path: "form",
      element: <SolarFormPage />,
      children: screenRoutes,
    },
    {
      path: "*",
      element: <ErrorPage />,
    },
  ]);

  return routes;
}
